import React, { Component } from "react";
import { connect } from "react-redux";
import { sendValidateAddAccount, setAuthorizedIdAdd } from "../../../domain/validation/validationActions";
import { closeModal } from "../../../domain/ui/uiActions";
import AuthIndividualForm from "../../forms/public/AuthIndividualForm";
import AuthorizedPerson from "../public/Registration/AuthorizedPerson/AuthorizedPerson";
class AuthIndividualAdd extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<AuthorizedPerson inModal>
				<AuthIndividualForm authIndividuals={this.props.validationInfo.authorized} requestData={this.props.validationInfo.validationRequest} sendValidation={this.props.sendValidateAddAccount} setAuthId={this.props.setAuthorizedIdAdd} closeModal={this.props.closeModal} modalTrigger="authIndividualAdd" fieldErrors={this.props.validationFieldErrors} isLoading={this.props.validationIsLoading}/>
			</AuthorizedPerson>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    validationFieldErrors: state.validation.fieldErrors,
    validationInfo: state.validation,
    validationIsLoading: state.validation.isLoading
});
const bindActionsToProps = {
    closeModal,
    sendValidateAddAccount,
    setAuthorizedIdAdd
};
/* Create and export container component that wraps AuthIndividualAdd for property binding */
export default connect(mapStateToProps, bindActionsToProps)(AuthIndividualAdd);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/modals/AuthIndividualAdd.tsx